export default function ({req, route, redirect, $config }) {
}
